module.exports = __webpack_public_path__ + "static/media/quote_start.bc4eb194.svg";